var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgITimezone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 52",
    style: {
      enableBackground: "new 0 0 20 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,16C4.5,16,0,20.5,0,26s4.5,10,10,10s10-4.5,10-10S15.5,16,10,16z M13.5,29l-3-3l5.8-5.8c0,0,0,0,0,0 C16.7,23.5,15.7,26.7,13.5,29z M6.5,23l3,3l-5.8,5.8c0,0,0,0,0,0C3.3,28.5,4.3,25.3,6.5,23z M15.8,19.7L10,25.5l-3-3 c2-1.9,4.6-2.9,7.4-2.9C14.9,19.6,15.3,19.6,15.8,19.7C15.8,19.7,15.8,19.7,15.8,19.7z M4.2,32.3l5.8-5.8l3,3 c-2,1.9-4.6,2.9-7.4,2.9C5.1,32.4,4.7,32.4,4.2,32.3C4.2,32.3,4.2,32.3,4.2,32.3z M14.8,18.9c-0.1,0-0.3,0-0.4,0 c-3,0-5.8,1.1-7.9,3.1l-2.3-2.3c1.5-1.4,3.6-2.3,5.8-2.3C11.8,17.4,13.4,18,14.8,18.9z M3.7,20.2L6,22.5c-2.1,2.2-3.2,5.2-3.1,8.3 c-0.9-1.4-1.5-3-1.5-4.8C1.4,23.8,2.3,21.7,3.7,20.2z M5.2,33.1c0.1,0,0.3,0,0.4,0c3,0,5.8-1.1,7.9-3.1l2.3,2.3 c-1.5,1.4-3.6,2.3-5.8,2.3C8.2,34.6,6.6,34,5.2,33.1z M16.3,31.8L14,29.5c2.1-2.2,3.2-5.2,3.1-8.3c0.9,1.4,1.5,3,1.5,4.8 C18.6,28.2,17.7,30.3,16.3,31.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgITimezone);
export default __webpack_public_path__ + "static/media/i_timezone.865570759aa8b164f956b0602f083c8b.svg";
export { ForwardRef as ReactComponent };